"use client";

import { useEffect, useState, useTransition } from "react";
import { atom, useAtom, useSetAtom } from "jotai";
import { usePathname, useRouter } from "next/navigation";
import cn from "@/utils/class-names";
import { Badge } from "@/components/ui/badge";
import { useCreateQueryString } from "@/hooks/use-create-query-string";
import MessageDetails from "@/app/shared/support/inbox/message-details";
import SimpleBar from "@/components/ui/simplebar";
import {
  dataAtom,
  messageIdAtom,
} from "@/app/shared/support/inbox/message-list";
import { messages } from "@/data/support-inbox";
import { ChatRoomType } from "@/types/requests/ChatRoom";
import { StateEveryType } from "@/types/global";
import useAxiosAuth from "@/hooks/fetch/useAxiosAuth";
import getData from "@/functions/getData";
import { apis } from "@/static/apis/apis";
import { Router } from "next/router";
import { routes } from "@/config/routes";

export const supportNavItems = [
  {
    value: "unassigned",
    label: "صاحب حواله",
    count: 1,
  },
  {
    value: "assigned-to-me",
    label: "پیشنهاد دهنده",
    count: 5,
  },
];

export const tabAtom = atom(supportNavItems[0].value);

export default function InboxTabs({
  className,
  id,
}: {
  className?: string;
  id: number;
}) {
  return <MessageDetails className={cn(className)} id={id} />;
}

export function TabList({
  id,
  chatData,
}: {
  id: number;
  chatData: StateEveryType<ChatRoomType> | undefined;
}) {
  const [tab, setTab] = useAtom(tabAtom);
  useEffect(() => {
    setTab(`${id}`);
  });
  const [isPending, startTransition] = useTransition();

  function selectTab(nextTab: string) {
    startTransition(() => {
      setTab(nextTab);
    });
  }
  const router = useRouter();
  const axios = useAxiosAuth();
  const [otherTab, setOtherTab] = useState<StateEveryType<any>>({
    data: undefined,
    loading: false,
    error: null,
  });
  const getChatRoom = () => {
    if (chatData && chatData.data)
      getData(
        apis.chatroom.showByBid(chatData.data.bid.id),
        axios,
        setOtherTab,
        "برو بریم",
        (res: StateEveryType<ChatRoomType[]>) => {
          res.data?.map((ele) => {
            if (ele.id !== chatData?.data?.id) router.push(routes.chat(ele.id));
          });
        }
      );
  };

  return (
    <SimpleBar>
      <nav className="flex items-center gap-5 border-b border-gray-300">
        <TabButton
          item={{
            name:
              chatData?.data?.owner.id === chatData?.data?.bid.owner.id
                ? "پیشنهاد دهنده"
                : "صاحب حواله",
          }}
          isActive={true}
          onClick={() => selectTab(`${1}`)}
          disabled={isPending}
          loading={false}
        />
        <TabButton
          item={{
            name:
              chatData?.data?.owner.id !== chatData?.data?.bid.owner.id
                ? "پیشنهاد دهنده"
                : "صاحب حواله",
          }}
          isActive={false}
          onClick={() => getChatRoom()}
          disabled={isPending}
          loading={otherTab.loading}
        />
      </nav>
    </SimpleBar>
  );
}

interface TabButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  item: { name: string };
  isActive: boolean;
  onClick: () => void;
  loading: boolean;
}
export function TabButton({
  item,
  isActive,
  onClick,
  loading,
  ...props
}: TabButtonProps) {
  const router = useRouter();
  const pathname = usePathname();
  const [data, setData] = useAtom(dataAtom);
  const setMessageId = useSetAtom(messageIdAtom);
  const { createQueryString } = useCreateQueryString();

  function handleClick() {
    // router.push(`${item.id}`);
    return onClick();
  }

  return (
    <button
      className={cn(
        "relative flex items-center gap-2 py-2 text-sm outline-none",
        isActive
          ? "font-medium text-gray-900"
          : "text-gray-500 hover:text-gray-800"
      )}
      onClick={onClick}
      {...props}
    >
      {loading ? (
        <>صبر کنید</>
      ) : (
        <>
          <span className="whitespace-nowrap">{item.name}</span>
          <span
            className={cn(
              "absolute -bottom-px left-0 h-0.5 w-full",
              isActive ? "bg-gray-900" : "bg-transparent"
            )}
          />
        </>
      )}
    </button>
  );
}
